import { createOAuthStateNonce } from '~/utils/oauth-state';

/** The auth-host half of `runtimeConfig.public.pb`. */
export interface AuthHostConfig {
    authApp?: string;
    authClientId?: string;
    authRedirectUri?: string;
    authResponseType?: string;
}

/**
 * The address that starts a sign-in at the auth host.
 *
 * `state` is what the callback gets back: where to land afterwards, the plan
 * selection to restore, and the CSRF nonce this tab stores now and checks then
 * (see oauth-state.ts). The path is the only thing about the current page that
 * travels, and a caller whose address must not leave the browser, such as the
 * proposal page, whose address is the link key, sends a fixed path and keeps
 * the rest in session storage.
 */
export function oauthAuthorizeUrl(pb: AuthHostConfig, state: { path: string; plan?: unknown; term?: unknown }): string {
    const nonce = createOAuthStateNonce();
    const encoded = encodeURIComponent(JSON.stringify({
        plan: state.plan ?? null,
        term: state.term ?? null,
        path: state.path,
        nonce,
    }));

    const redirectUri = encodeURIComponent(pb.authRedirectUri as string);
    const responseType = pb.authResponseType || 'code';

    return `${pb.authApp}?response_type=${responseType}&client_id=${pb.authClientId}&redirect_uri=${redirectUri}&state=${encoded}`;
}
